const swapBodyClass = (index) => {
    const toRemove = Array.from(document.body.classList).filter((klass) =>
        klass.includes('nav-active')
    );
    if (toRemove.length) document.body.classList.remove(...toRemove);
    if (index) document.body.classList.add('nav-active', `nav-active-${index}`);
};

// Delay mouseleave
const items = document.querySelectorAll('.Navigation > .has-children');

let timeout;

items.forEach((item, index) => {
    item.dataset.index = index + 1;
    item.addEventListener('mouseenter', () => {
        clearTimeout(timeout);
        // Remove existing active classes
        swapBodyClass(item.dataset.index);
    });

    item.addEventListener('mouseleave', () => {
        timeout = setTimeout(() => {
            swapBodyClass();
        }, 250);
    });
});
